import { currencyAtom } from "@/atoms/currencyAtom"
import { Transporters } from "@/types/organizations.types"
import { DefaultText } from "@/UI"
import { Switch } from "antd"
import { useTranslation } from "react-i18next"
import React from "react"
import { useRecoilValue } from "recoil"
import { Currency } from "@/types/currencies.types"
import { orgCountryAtom } from "@/atoms/userAtom"

interface TransporterSelectorProps {
  channel: Transporters
  active: boolean
  isRecipients: boolean
  isLoading: boolean
  onChange: (channel: Transporters, value: boolean) => void
  disabled?: boolean
}

const notificationsPrices = (countryCode: string, transport: Transporters): number => {
  if (transport === Transporters.WHATSAPP) {
    return (
      {
        SG: 0.08,
        MY: 0.3,
        ES: 0.05,
        NL: 0.1,
        IT: 0.06,
        // BRL: 0.35,
        // THB: 2.5,
        // PHP: 4,
        // IDR: 1,
        // COP: 0.35,
        // EUR: 0.1,
        // HKD: 0.55,
        // JPY: 15,
        // USD: 0.1,
        // HUF: 35,
      }[countryCode] || 0.1
    )
  }
  if (transport === Transporters.SMS) {
    return (
      {
        SG: 0.06,
        MY: 0.3,
        ES: 0.09,
        NL: 0.1,
        IT: 0.1,
        // BRL: 0.35,
        // THB: 2.5,
        // PHP: 4,
        // IDR: 1,
        // COP: 0.35,
        // EUR: 0.1,
        // HKD: 0.55,
        // JPY: 15,
        // USD: 0.1,
        // HUF: 35,
      }[countryCode] || 0.1
    )
  }
  return 0
}

const getNotificationsCurrency = (currency: Currency): Currency => {
  if (currency.code === "SGD" || currency.code === "MYR" || currency.code === "EUR") {
    return currency
  }
  return { code: "USD", symbol: "$" }
}

const TransporterSelector: React.FC<TransporterSelectorProps> = ({
  channel,
  active,
  onChange,
  isRecipients,
  isLoading,
  disabled,
}) => {
  const { t } = useTranslation()
  const currency = useRecoilValue(currencyAtom)
  const notificationsCurrency = getNotificationsCurrency(currency)
  const country = useRecoilValue(orgCountryAtom)

  const settingText = isRecipients
    ? `profile.NotificationsSettings.recipient_${channel}`
    : `profile.NotificationsSettings.${channel}`

  return (
    <div className="grid grid-cols-12" id={channel}>
      <div className="col-span-2 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 2xl:col-span-1">
        <Switch
          checked={active}
          onChange={(value) => onChange(channel, value)}
          loading={isLoading}
          disabled={disabled}
        />
      </div>
      <div className="col-span-10 sm:col-span-11 md:col-span-11 lg:col-span-11 xl:col-span-11 2xl:col-span-11">
        <div className="flex flex-col">
          <DefaultText>{t(settingText)}</DefaultText>
          {Transporters.WHATSAPP === channel && (
            <p className="text-gray-400">
              {t("profile.NotificationsSettings.notificationsPrice", {
                currency: notificationsCurrency.symbol,
                amount: notificationsPrices(country, Transporters.WHATSAPP)?.toFixed(2),
              })}
            </p>
          )}
          {Transporters.SMS === channel && (
            <p className="text-gray-400">
              {t("profile.NotificationsSettings.notificationsPrice", {
                currency: notificationsCurrency.symbol,
                amount: notificationsPrices(country, Transporters.SMS)?.toFixed(2),
              })}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default TransporterSelector
